var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01562 3.82121C2.01562 2.64355 2.01562 2.05473 2.26117 1.73014C2.47508 1.44737 2.80204 1.27239 3.15597 1.25126C3.56225 1.227 4.05218 1.55362 5.03204 2.20687L17.7834 10.7078C18.5931 11.2476 18.9979 11.5174 19.139 11.8576C19.2623 12.155 19.2623 12.4892 19.139 12.7866C18.9979 13.1268 18.5931 13.3967 17.7834 13.9365L5.03204 22.4374C4.05218 23.0906 3.56225 23.4173 3.15597 23.393C2.80204 23.3719 2.47508 23.1969 2.26117 22.9141C2.01562 22.5895 2.01562 22.0007 2.01562 20.8231V3.82121Z",
    stroke: "#243677",
    strokeWidth: 2.42524,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.c1ff4bdc7140c9560e04d9e048a4eed5.svg";
export { ForwardRef as ReactComponent };